import SmsScreen from "components/shared/SmsScreen"
import { SMS_SUCCESS_TEXT } from "shared/constants"
import { useHistory } from "react-router-dom"
import { useForceAuthEffect } from "components/Login/hooks"
import successIcon from "./assets/success-checkmark.svg"

const SmsSuccess = () => {
  useForceAuthEffect({ authUrl: "/login" })
  const history = useHistory()

  const handleGoToHome = () => {
    history.replace("/")
  }

  return (
    <SmsScreen
      heading={SMS_SUCCESS_TEXT.heading}
      description={SMS_SUCCESS_TEXT.description}
      icon={successIcon}
      hideBackButton={false}
      buttons={[
        {
          text: SMS_SUCCESS_TEXT.homeButton,
          primary: true,
          to: "/",
          onClick: handleGoToHome
        }
      ]}
    />
  )
}

export default SmsSuccess
